var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',{staticClass:"blockquote"},[_c('p',{staticClass:"italic"},[_vm._v(" "+_vm._s(_vm.quote)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }